import styled from "styled-components";

export const MainContainer = styled.div``;
